/**
 * DEVELOPER NOTE: INFORMATION ON THIS SERVICE / FUNCTION
 *
 * Using this service to hot reload the application if the browser caches the app and this leads
 * to a failed to load dynamically imported module errors. On new deployments!
 */

import { isPlatformBrowser } from '@angular/common';
import { ErrorHandler, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChunkErrorService {
  private _error$ = new BehaviorSubject<boolean>(false);
  error$ = this._error$.asObservable();

  notifyError() {
    this._error$.next(true);
  }
}

@Injectable()
export class ReloadOnChunkFailHandler implements ErrorHandler {
  constructor(
    private chunkError: ChunkErrorService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  handleError(error: any): void {
    const errorMessage = error?.message || error?.toString?.();

    if (
      errorMessage?.includes('Loading chunk') ||
      errorMessage?.includes('dynamically imported module')
    ) {
      console.warn('Chunk load failed. Showing reload banner...');
      console.error(error);
      this.chunkError.notifyError();
    } else if (isPlatformBrowser(this.platformId)) {
      // Re-throw in browser so Angular shows its normal error UI
      throw error;
    } else {
      // On server/prerender, just log so it doesn't crash Node
      console.error('SSR error (ignored by ReloadOnChunkFailHandler):', error);
    }
  }
}
